(function () {
  function bind(el, event, fn) {
    if (!el) return;
    el.__zlp02Bound = el.__zlp02Bound || {};
    if (el.__zlp02Bound[event]) return;
    el.__zlp02Bound[event] = true;
    el.addEventListener(event, fn);
  }
  function init() {
    const page = document.getElementById('main');
    if (!page) return;
    const all = selector => [...page.querySelectorAll(selector)];
    function gallery(index) {
      const slides = all('.lp02-product-slide');
      slides.forEach((el, i) => el.classList.toggle('lp02-active', i === index));
      all('[data-gallery]').forEach((el, i) => el.setAttribute('aria-pressed', String(i === index)));
      const label = page.querySelector('#gallery-name');
      if (label && slides[index]) label.textContent = slides[index].dataset.galleryName || label.textContent;
    }
    all('[data-gallery]').forEach(el => bind(el, 'click', () => gallery(Number(el.dataset.gallery))));
    all('[data-pick]').forEach(el => bind(el, 'click', () => {
      gallery(Number(el.dataset.pick));
      const panel = page.querySelector('#buyingPanel');
      panel?.scrollIntoView({ behavior: 'smooth' });
      const name = el.querySelector(':scope > span')?.textContent.trim();
      const button = all('[data-frag]').find(button => button.dataset.name?.includes(name));
      button?.click();
    }));
    all('[data-dialog]').forEach(el => bind(el, 'click', () => {
      const dialog = page.querySelector('#' + el.dataset.dialog);
      if (dialog && !dialog.open) dialog.showModal();
    }));
    all('.lp02-close-dialog').forEach(el => bind(el, 'click', () => el.closest('dialog').close()));
    all('dialog').forEach(dialog => bind(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    }));
    const rail = page.querySelector('.lp02-collection-rail');
    bind(page.querySelector('#rail-prev'), 'click', () => rail?.scrollBy({ left: -rail.clientWidth * .7, behavior: 'smooth' }));
    bind(page.querySelector('#rail-next'), 'click', () => rail?.scrollBy({ left: rail.clientWidth * .7, behavior: 'smooth' }));
  }
  function sticky() {
    const hero = document.getElementById('hero');
    const panel = document.getElementById('buyingPanel');
    const bar = document.getElementById('sticky-cta');
    if (!hero || !panel || !bar) return;
    const h = hero.getBoundingClientRect(), p = panel.getBoundingClientRect();
    bar.classList.toggle('lp02-visible', h.bottom < 70 && !(p.top < innerHeight * .6 && p.bottom > innerHeight * .4));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('scroll', sticky, { passive: true });
  window.addEventListener('resize', sticky);
})();

